import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { contentDetailsFetcher } from 'src/lib/fetchers/content-fetchers';

type Props = {
  data: ContentDetails[];
  isLoading: boolean;
};
export const CONTENT_DETAIL_ID_QUERY_KEY = (contentId: string) => 'content-detail-id-' + contentId;
const useContentDetails = ({
  contentId,
  type,
  programId,
  subjectId,
  chapterId,
  topicId,
  enabled,
}: {
  enabled?: boolean;
  contentId: string;

  type: string;
  programId: string;
  subjectId: string;
  chapterId: string;
  topicId: string;
}): Props => {
  const { data, isLoading } = useQuery(
    [
      CONTENT_DETAIL_ID_QUERY_KEY(contentId),
      {
        params: { type, programId, subjectId, chapterId, topicId, contentId },
      },
    ],
    contentDetailsFetcher,
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled:
        enabled !== false &&
        !!contentId &&
        !!type &&
        !!programId &&
        !!subjectId &&
        !!chapterId &&
        !!topicId,
      staleTime: 1000 * 60 * 60,
    },
  );
  console.log('DATa<>><<', data?.data);
  const Data: ContentDetails[] = useMemo(() => {
    return data?.data;
  }, [data]);
  return {
    data: Data,
    isLoading,
  };
};

export default useContentDetails;

export class ContentDetails {
  _id: string;
  title: string;
  content: Content[];
  type: string;
  actions: string[];
  availableFor: string[];
  isAvailableFromPoints: boolean;
  isImportant: boolean;
  isLive: boolean;
  price: number;
  programId: ProgramId;
  restrictContent: boolean;
  restrictionCount: number;
  teachers: any[];
  isPurchased: boolean;
  isBookmarked: boolean;
  isLiked: boolean;
  myRating: any;
  avgRating: any;
  meta: any[];
  subjectId: SubjectId;
  chapterId: ChapterId;
  constructor(data: any) {
    data = data || {};
    this._id = data?._id || '';
    this.title = data.title || '';
    let list: any;
    if (data && data.content && data.content.length > 0) {
      data.content.forEach((el: Content) => {
        list.push(new Content(el));
      });
    }
    this.content = [...list] || [];
    this.type = data?.type || '';
    this.actions = data?.actions || [];
    this.availableFor = data?.availableFor || [];
    this.isAvailableFromPoints = data?.isAvailableFromPoints || false;
    this.isImportant = data?.isImportant || false;
    this.isLive = data?.isLive || false;
    this.price = data?.price || 0;
    this.programId = new ProgramId(data?.programId || {});
    this.restrictContent = data?.restrictContent || false;
    this.restrictionCount = data?.restrictionCount || 0;
    this.teachers = data?.teachers || [];
    this.isPurchased = data?.isPurchased || false;
    this.isBookmarked = data?.isBookmarked || false;
    this.isLiked = data?.isLiked || false;
    this.myRating = data?.myRating || '';
    this.avgRating = data?.avgRating || '';
    this.meta = data?.meta || [];
    this.subjectId = new SubjectId(data?.subjectId || {});
    this.chapterId = new ChapterId(data?.ChapterId || {});
  }
}

export class Content {
  _id: string;
  text: string;
  timeline: any[];
  videoType: string;
  videoUrl: string;
  videoDetails: VideoDetails;
  constructor(data: any) {
    data = data || {};
    this._id = data?._id || '';
    this.text = data?.text || '';
    this.timeline = data?.timeline || [];
    this.videoType = data?.videoType || '';
    this.videoUrl = data?.videoUrl || '';
    this.videoDetails = new VideoDetails(data?.videoDetails || {});
  }
}

export class VideoDetails {
  _id: string;
  id: string;
  name: string;
  image: string;
  videoUrl: string;
  description: string;
  duration: string;
  status: string;
  types: string[];
  createdAt: string;
  drmProtected: boolean;
  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.id = data.id || '';
    this.name = data.name || '';
    this.image = data.image || '';
    this.videoUrl = data.videoUrl || '';
    this.description = data.description || '';
    this.duration = data.duration || '';
    this.status = data.status || '';
    this.types = data.types || [];
    this.createdAt = data.createdAt || '';
    this.drmProtected = data.drmProtected || false;
  }
}

export class ProgramId {
  _id: string;
  isSpecial: boolean;
  slug: string;
  constructor(data: any) {
    data = data || {};
    this._id = data?._id || '';
    this.isSpecial = data?.isSpecial || false;
    this.slug = data?.slug || '';
  }
}

export class SubjectId {
  _id: string;
  name: string;
  constructor(data: any) {
    data = data || {};
    this._id = data?._id || '';
    this.name = data?.name || '';
  }
}

export class ChapterId {
  _id: string;
  name: string;
  constructor(data: any) {
    data = data || {};
    this._id = data?._id || '';
    this.name = data?.name || '';
  }
}
